import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  const maxVisible = 5;
  const pages = [];

  for (let i = 1; i <= Math.min(totalPages, maxVisible); i++) {
    pages.push(i);
  }

  const handlePageClick = (page) => {
    if (page !== currentPage) onPageChange(page);
  };

  const containerStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
    padding: "8px 16px",
    display: "inline-flex",
    alignItems: "center",
    gap: "16px",
  };

  const pageStyle = (isActive) => ({
    color: isActive ? "rgb(24, 144, 255)" : "#999",
    fontWeight: isActive ? "bold" : "normal",
    cursor: "pointer",
  });

  const iconStyle = (disabled) => ({
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.3 : 1,
  });

  return (
    <div className="d-flex justify-content-end my-4">
      <div style={containerStyle}>
        <FaChevronLeft
          size={16}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          style={iconStyle(currentPage === 1)}
        />

        {pages?.map((page) => (
          <span
            key={page}
            style={pageStyle(currentPage === page)}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </span>
        ))}

        {totalPages > maxVisible && (
          <>
            <span style={{ color: "#999" }}>...</span>
            <span
              style={pageStyle(currentPage === totalPages)}
              onClick={() => handlePageClick(totalPages)}
            >
              {totalPages}
            </span>
          </>
        )}

        <FaChevronRight
          size={16}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
          style={iconStyle(currentPage === totalPages)}
        />
      </div>
    </div>
  );
};

export default PaginationComponent;
